module.exports = "https://cdn.redage.net/src/views/player/menu/elements/fractions/elements/tasks/images/6.png";